import { GridCol, GridRow, PageMargins, TypographyV2 } from "@components/index";
import React from "react";
import * as styles from "./_JoinInstitutionsV2.module.scss";
import { EllipseBottom, EllipseTop, EllipseTop2 } from "@assets/Background";
import {
	GhostSignUpButtonV2,
	JoinTIRequestDemoButtonV2,
} from "@components/Button_new/Button";
import { useWindowSize } from "@helpers/Hooks";
import classNames from "classnames";
import Typography from "@components/Typography/Typography";
import styled, { css } from "styled-components";

type JoinInstitutionsContainerProps = {
	className?: string;
	hasHeaderTextAndSubheaderText: boolean;
};
export const JoinInstitutionsContainer = styled.div.attrs<JoinInstitutionsContainerProps>(
	(props: { className: string }) => ({
		className: props.className,
	})
)<JoinInstitutionsContainerProps>`
	@media (max-width: 769px) {
		${(props: { hasHeaderTextAndSubheaderText: boolean }) =>
			props.hasHeaderTextAndSubheaderText &&
			css`
				height: 576px;
			`}
	}

	@media (max-width: 1024px) {
		${(props: { hasHeaderTextAndSubheaderText: boolean }) =>
			props.hasHeaderTextAndSubheaderText &&
			css`
				height: 404px;
			`}
	}
`;

export const JoinInstitutionsInnerContainer = styled.div.attrs<JoinInstitutionsContainerProps>(
	(props: { className: string }) => ({
		className: props.className,
	})
)<JoinInstitutionsContainerProps>`
	@media (min-width: 1024px) {
		${(props: { hasHeaderTextAndSubheaderText: boolean }) =>
			props.hasHeaderTextAndSubheaderText &&
			css`
				width: 900px;
			`}
	}
`;

type Props = {
	outerContainerClassName?: string;
	headerText?: string;
	subheaderText?: string;
	useHeaderStylesV4?: boolean;
	useSubheaderStylesV4?:boolean;
	joinInstitutionsContainerOverride?:boolean;
};

export const JoinInstitutionsV2 = ({
	outerContainerClassName,
	headerText,
	subheaderText,
	useHeaderStylesV4,
	useSubheaderStylesV4,
	joinInstitutionsContainerOverride
}: Props) => {
	const hasHeaderTextAndSubheaderText = !!headerText && !!subheaderText;

	return (
		<div
			className={classNames(
				styles.outerContainer,
				outerContainerClassName
			)}
		>
			<GridCol className={styles.colContainer}>
				<div className={styles.rowContainer}>
					<JoinInstitutionsContainer
						className={classNames(styles.joinInstitutionsContainer,joinInstitutionsContainerOverride )}
						hasHeaderTextAndSubheaderText={
							hasHeaderTextAndSubheaderText
						}
					>
						<div className={styles.ellipseTopBackgroundShape}>
							<EllipseTop />
						</div>
						<div className={styles.ellipseTop2BackgroundShape}>
							<EllipseTop2 />
						</div>
						<div className={styles.ellipseBottomBackgroundShape}>
							<EllipseBottom />
						</div>
						<JoinInstitutionsInnerContainer
							className={styles.innerContainer}
							hasHeaderTextAndSubheaderText
						>
							<div>
								<TypographyV2
									color="ui-01"
									className={
										headerText
											? classNames(styles.header2, {
													[styles.headerV4]:
														useHeaderStylesV4,
											  })
											: styles.header
									}
								>
									{headerText
										? headerText
										: "Join the hundreds of companies that rely on Genemod to enhance their lab efficiency"}
								</TypographyV2>
								{subheaderText && (
									<Typography
										color="ui-01"
										className={classNames(styles.subheader, {
											[styles.subheaderV4] : useSubheaderStylesV4
										})}
									>
										{subheaderText}
									</Typography>
								)}
							</div>
							<div className={styles.buttonsContainer}>
								<GhostSignUpButtonV2 title="Sign up free"/>
								<JoinTIRequestDemoButtonV2 title="Request demo"/>
							</div>
						</JoinInstitutionsInnerContainer>
					</JoinInstitutionsContainer>
				</div>
			</GridCol>
		</div>
	);
};
